import React, { Component } from "react";
import YETwoPropertyHighlightModal from "./PropertyHighlightModal";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import YETwoHighlightsProp from "./HighlightsProp";
import QVFourTestimonial from "../QVFourTestimonial";

class YETwoPropertyHighlight extends Component {
  state = {
    isModalOpen: false,
  };
  isUnit = (prop) => {};

  formatSalePrice = (price) => {
    let salePriceOnlyNumbers = ((price || 0) + "").replace(/\D/g, "");
    return Number(salePriceOnlyNumbers);
  };
  determineTitleYear = (useAlt) => {
    const { title } = this.props;
    const { mlsAreaID } = this.props.currentArea;
    let titleStyles = "";
    let titleLength = title ? title.length : 1;

    return (
      <div className="ye2-property-highlight-title-top-row">
        <div
          className={`${
            useAlt
              ? "alt-y2-property-highlight-title-text"
              : "y2-property-highlight-title-text"
          } ${titleStyles}`}
        >
          {title}
        </div>
      </div>
    );
  };
  handlePropertyHighlightDialog = (openDialog = false) => {
    this.setState({
      isModalOpen: openDialog,
    });
  };

  photoURLToUse = (prop) => {
    let url;
    if (prop.optimizedPhotoURL === "ERROR") {
      url = prop.photoURL;
    } else if (prop.optimizedPhotoURL) {
      url = prop.optimizedPhotoURL;
    } else {
      url = prop.photoURL;
    }
    return url;
  };

  render() {
    let {
      currentSoldListings,
      mlsAreaID,
      isAgentPage,
      subtitle,
      footerText1,
      onHighlightTitleOpen,
      onHighlightFooterOpen,
      agentData,
      printVersion,
      fromEditor,
      currentArea,
      openEditDialogFn,
      testimonials,
      isDraggable,
      activeId,
      SortablePhotoWrapper,
      handleSelect,
    } = this.props;

    const { listgenUserID } = agentData;
    let highlightContainerStyles;
    let subtitleStyles;
    if (listgenUserID === "107280") {
      subtitleStyles = "smaller-less-line-height";
    } else if (subtitle && subtitle.length >= 650) {
      subtitleStyles = "smaller-ye2-subtitle-text";
    } else if (subtitle && subtitle.length >= 300) {
      subtitleStyles = "smaller-ye2-subtitle-text-15";
    } else if (listgenUserID === "100462") {
      subtitleStyles = "column-subtitle-styles";
    }
    if (listgenUserID === "105067") {
      highlightContainerStyles = "property-highlight-700";
    } else if (subtitle && subtitle.length >= 500) {
      highlightContainerStyles = "xl-highlights";
    } else if (listgenUserID === "x102843") {
      highlightContainerStyles = "taller-higlights-bg";
    }
    let useSmallerFooterFont = false;
    if (footerText1 && footerText1.length >= 80) {
      useSmallerFooterFont = true;
    }
    let useAlt = true;
    const { handlePropertyHighlightDialog } = this;
    const { isModalOpen } = this.state;
    let isGalliTeam = listgenUserID === "x102843";
    let extraQuadrantStyles;
    if (isGalliTeam) {
      extraQuadrantStyles = "galli-prop-layout";
    }
    let use1Prop3Photos = false;
    let use1Prop = false;
    let use2Props = false;
    let useQuadrantPhotoProps = false;
    let use3Props = false;
    let use4Props = false;
    let switchedProperties = false;
    let backgroundStyles = "";
    let use6Props = false;

    if (currentSoldListings && currentSoldListings.length === 1) {
      use1Prop = true;
    } else if (currentSoldListings && currentSoldListings.length === 2) {
      use2Props = true;
      backgroundStyles = "two-prop-bg";
    } else if (currentSoldListings && currentSoldListings.length === 3) {
      use3Props = true;
    } else {
      useQuadrantPhotoProps = true;
    }

    //let showButton = true;
    if (listgenUserID === "x108197") {
      use6Props = true;
      useQuadrantPhotoProps = false;
    }
    const { showAllEditButtons } = this.props;
    let showButton = showAllEditButtons;

    // if (listgenUserID === "100074" || listgenUserID === "109879") {
    //adding console log
    // }

    let showSwitchButtons = false;
    let col2Styles;
    let altYe2PropHighlightBGStyles;
    let has3Footers = "";
    // Function to check if any property has all three footer values

    let propTitleStyles;

    if (listgenUserID === "100047") {
      showSwitchButtons = true;
    }
    if (use1Prop) {
      propTitleStyles = "one-prop-title";
    }
    // if (!subtitle) {
    //   propTitleStyles = "prop-title-styles-182";
    // }

    const checkForThreeFooters = () => {
      if (use1Prop) {
        return false;
      }
      return currentSoldListings.some((prop) => {
        return (
          prop.footerText1 &&
          prop.footerText2 &&
          prop.courtesyText1 &&
          prop.footerText1.trim() !== "" &&
          prop.footerText2.trim() !== "" &&
          prop.courtesyText1.trim() !== ""
        );
      });
    };

    // Set has3Footers based on the check
    has3Footers = checkForThreeFooters();
    let row1 = (
      <div className="ye2-property-highlight-row-1">
        <div className="ye2-property-highlight-inner-photo-container">
          {[2, 3, 4].map((placeholder, index) => {
            let prop = currentSoldListings[index + 2];

            if (!prop) {
              return (
                <div
                  className="property-highlight-placeholder"
                  key={placeholder}
                >
                  <p>Please select</p>
                  <p>a property</p>
                </div>
              );
            } else {
              const photoContent = (
                <div className="row1-photo-col" key={placeholder}>
                  {isAgentPage && showButton ? (
                    <div>
                      <div className="property-number">{index + 3}</div>
                      {handleSelect && (
                        <button
                          className="property-delete-btn"
                          style={{
                            position: "absolute",
                            top: "40px",
                            left: "5px",
                            fontSize: "12px",
                            fontWeight: "bold",
                            border: "1px solid #dc3545",
                            borderRadius: "3px",
                            width: "50px",
                            height: "18px",
                            background: "#fff",
                            color: "#dc3545",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "0",
                            zIndex: 10001,
                          }}
                          title="Delete Property"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelect(prop, false);
                          }}
                        >
                          Delete
                        </button>
                      )}
                      <div
                        className="property-edit-photo-btn"
                        onClick={() => openEditDialogFn(prop)}
                      >
                        Edit
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}
                  <YETwoHighlightsProp
                    prop={prop}
                    agentData={agentData}
                    currentSoldListings={currentSoldListings}
                    useAlt={useAlt}
                    has3Footers={has3Footers}
                  />
                </div>
              );

              return isDraggable && SortablePhotoWrapper ? (
                <SortablePhotoWrapper
                  key={placeholder}
                  prop={prop}
                  activeId={activeId}
                >
                  {photoContent}
                </SortablePhotoWrapper>
              ) : (
                photoContent
              );
            }
          })}
        </div>
      </div>
    );

    let row2 = (
      <div className="ye2-property-highlight-row-2">
        <div className="ye2-property-highlight-inner-photo-container">
          {[0, 1].map((placeholder, index) => {
            let prop = currentSoldListings[index];

            if (!prop) {
              return (
                <div
                  className="property-highlight-placeholder"
                  key={placeholder}
                >
                  <p>Please select</p>
                  <p>a property</p>
                </div>
              );
            } else {
              const photoContent = (
                <div className="row2-photo-col" key={placeholder}>
                  {isAgentPage && showButton ? (
                    <div>
                      <div className="property-number">{index + 1}</div>
                      {handleSelect && (
                        <button
                          className="property-delete-btn"
                          style={{
                            position: "absolute",
                            top: "40px",
                            left: "5px",
                            fontSize: "12px",
                            fontWeight: "bold",
                            border: "1px solid #dc3545",
                            borderRadius: "3px",
                            width: "50px",
                            height: "18px",
                            background: "#fff",
                            color: "#dc3545",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "0",
                            zIndex: 10001,
                          }}
                          title="Delete Property"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelect(prop, false);
                          }}
                        >
                          Delete
                        </button>
                      )}
                      <div
                        className="property-edit-photo-btn"
                        onClick={() => openEditDialogFn(prop)}
                      >
                        Edit
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}
                  <YETwoHighlightsProp
                    prop={prop}
                    agentData={agentData}
                    currentSoldListings={currentSoldListings}
                    useAlt={useAlt}
                    has3Footers={has3Footers}
                  />
                </div>
              );

              return isDraggable && SortablePhotoWrapper ? (
                <SortablePhotoWrapper
                  key={placeholder}
                  prop={prop}
                  activeId={activeId}
                >
                  {photoContent}
                </SortablePhotoWrapper>
              ) : (
                photoContent
              );
            }
          })}
        </div>
      </div>
    );
    return (
      <div
        className={`${
          isAgentPage
            ? `ye2-agent-page-property-highlight ${
                useAlt && "alt-ye2-property-highlight"
              } ${highlightContainerStyles}`
            : `ye2-property-highlight ${
                useAlt && "alt-ye2-property-highlight"
              } ${highlightContainerStyles}`
        }`}
      >
        {isModalOpen && (
          <YETwoPropertyHighlightModal
            isModalOpen={isModalOpen}
            handlePropertyHighlightDialog={handlePropertyHighlightDialog}
          />
        )}

        {!isAgentPage && fromEditor && showButton && (
          <div
            className={`ye2-new-edit-button-container ${
              useAlt
                ? "gummow-alt-prop-edit-button-container"
                : "regular-prop-edit-button"
            }`}
          >
            <Link
              to={`/agent/property-highlights/${
                currentArea && currentArea.mlsAreaID
              }`}
              className="ye2-new-edit-button"
            >
              Edit This Page
            </Link>
          </div>
        )}
        {useAlt ? (
          <div className="alt-ye2-property-highlight-bg-container">
            <div
              className={`alt-ye2-property-highlight-bg ${altYe2PropHighlightBGStyles}`}
            ></div>
          </div>
        ) : (
          <div
            className={`ye2-property-highlight-bg-container ${backgroundStyles}`}
          >
            <div className="ye2-property-highlight-bg"></div>
          </div>
        )}

        <div className="ye2-property-highlight-body">
          {mlsAreaID === "xSMA-448" ? (
            <div className="ye2-property-highlight-title-container">
              {this.determineTitleYear()}
              <div className={`ye2-property-subtitle ${subtitleStyles}`}>
                <p>
                  When listing your home, we become your negotiator, project
                  coordinator and proven marketer. When helping you buy a home,
                  we use our depth of experience to strategize a winning offer.
                  Our latest Hillsborough seller, Richard on Hayne Road, summed
                  it up this way: <br />
                  "You won’t find a better real estate team in the area."
                </p>
              </div>
            </div>
          ) : useAlt === "x" ? (
            <div className="alt-ye2-property-highlight-title-container">
              {this.determineTitleYear(useAlt)}
              <div className="alt-ye2-property-subtitle">
                <p>
                  We want to take a moment to appreciate all our clients,
                  friends, and neighbors who have trusted us in achieving their
                  real estate goals! Working with so many kind and interesting
                  people is a testament to the passion we have for serving our
                  community.
                </p>
              </div>
            </div>
          ) : useAlt == "previous-version-gummow" ? (
            <div className="alt-ye2-property-highlight-title-container">
              <div className="gummow-qr">
                <img src="https://d2onbxnrte2nim.cloudfront.net/GUMMOWBROTHERS_QRcode_blackBG.png" />
              </div>
              <div className="gummow-arrow">
                <img src="https://d2onbxnrte2nim.cloudfront.net/gummow-arrow-highlights.png" />
              </div>
              <div className="ye2-property-highlight-title-top-row">
                <div className={`alt-y2-property-highlight-title-text `}>
                  How much is your home worth?
                </div>
              </div>
              <div className="alt-scan-here">
                <p>Scan Here</p>
              </div>
              <div className="alt-ye2-property-subtitle">
                <p>
                  A sampling of some of the beautiful homes we represented for
                  both Sellers and Buyers
                </p>
              </div>
            </div>
          ) : listgenUserID === "x100462" ? (
            <div className="ye2-property-highlight-title-container">
              {this.determineTitleYear()}
              <div className={`ye2-property-subtitle ${subtitleStyles}`}>
                <p>
                  4 BEDROOMS | 4 FULL + 2 HALF BATHS | 1 BD/1 BA GUEST HOUSE
                </p>
                <p>
                  5,669± SQ FT MAIN HOUSE | 472 SQ FT± GUEST HOUSE | .64 ACRES
                </p>
                <p></p>
              </div>
            </div>
          ) : listgenUserID === "x103455" ? (
            <div className="ye2-property-highlight-title-container">
              {this.determineTitleYear()}
              <div className={`ye2-property-subtitle ${subtitleStyles}`}>
                <p>New Listing</p>
                <p>
                  5940 Encina Road #4 | 2 Bedroom + Den | 2 Bath | End Unit |
                  Offered at $649,000
                </p>
                <p></p>
              </div>
            </div>
          ) : listgenUserID === "109882" && subtitle.includes("<br />") ? (
            <div
              className={`${
                useAlt
                  ? "alt-ye2-property-highlight-title-container"
                  : "ye2-property-highlight-title-container"
              }`}
            >
              {this.determineTitleYear(useAlt)}
              <div
                className={`${
                  useAlt ? "alt-ye2-property-subtitle" : "ye2-property-subtitle"
                } ${subtitleStyles} subtitle-column`}
              >
                <p>{subtitle.split("<br />")[0]}</p>
                <p>{subtitle.split("<br />")[1]}</p>
              </div>
            </div>
          ) : (
            <div
              className={`${
                useAlt
                  ? "alt-ye2-property-highlight-title-container"
                  : "ye2-property-highlight-title-container"
              } ${propTitleStyles}`}
            >
              {this.determineTitleYear(useAlt)}
              <div
                className={`${
                  useAlt ? "alt-ye2-property-subtitle" : "ye2-property-subtitle"
                } ${subtitleStyles}`}
              >
                <p>{subtitle}</p>
              </div>
            </div>
          )}
          {listgenUserID !== "x105918" && (
            <div className="y2-property-highlight-footer">
              <div className="y2-property-highlight-custom-footer-text">
                <div
                  className={`${
                    useAlt
                      ? "alt-ye2-property-highlight-footer-text-1"
                      : "ye2-property-highlight-photo-title-text"
                  } prop-highlight-footer-text-1 ${
                    useSmallerFooterFont && "smaller-footer-1-text"
                  }`}
                >
                  {footerText1 ? footerText1 : ""}
                </div>

                <div
                  className={`${
                    useAlt
                      ? "alt-ye2-property-highlight-footer-text-2"
                      : "ye2-property-highlight-photo-title-text prop-highlight-footer-text-2"
                  }`}
                ></div>
                {isAgentPage && showButton ? (
                  <div
                    className="title-edit-button footer-btn"
                    onClick={() => onHighlightFooterOpen()}
                  >
                    <div>
                      <p>edit</p>
                      <p>Footer</p>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            </div>
          )}
          {isAgentPage && showButton ? (
            <div
              className="title-edit-button title-btn"
              onClick={() => onHighlightTitleOpen()}
              // style={{ marginTop: "-16px", marginBottom: "16px" }}
            >
              <div>
                <p>edit</p>
                <p>Title & Subtitle</p>
              </div>
            </div>
          ) : (
            <div></div>
          )}
          {useQuadrantPhotoProps ? (
            <div
              className={`ye2-property-highlight-row-1 ${
                extraQuadrantStyles
                  ? extraQuadrantStyles
                  : "quadrant-prop-layout"
              }`}
            >
              <div className="ye2-property-highlight-inner-photo-container">
                <div className="ye2-prop-highlights-col-1">
                  {[0, 1].map((placeholder, index) => {
                    let prop = currentSoldListings[index];
                    const photoContent = (
                      <div className="row1-photo-col" key={placeholder}>
                        {isAgentPage && showButton ? (
                          <div>
                            <div className="property-number">{index + 1}</div>
                            {handleSelect && (
                              <button
                                className="property-delete-btn"
                                style={{
                                  position: "absolute",
                                  top: "40px",
                                  left: "5px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  border: "1px solid #dc3545",
                                  borderRadius: "3px",
                                  width: "50px",
                                  height: "18px",
                                  background: "#fff",
                                  color: "#dc3545",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "0",
                                  zIndex: 10001,
                                }}
                                title="Delete Property"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelect(prop, false);
                                }}
                              >
                                Delete
                              </button>
                            )}
                            <div
                              className="property-edit-photo-btn"
                              onClick={() => openEditDialogFn(prop)}
                            >
                              Edit
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        <YETwoHighlightsProp
                          prop={prop}
                          agentData={agentData}
                          currentSoldListings={currentSoldListings}
                          useAlt={useAlt}
                          has3Footers={has3Footers}
                          index={index}
                        />
                      </div>
                    );

                    return isDraggable && SortablePhotoWrapper ? (
                      <SortablePhotoWrapper
                        key={placeholder}
                        prop={prop}
                        activeId={activeId}
                      >
                        {photoContent}
                      </SortablePhotoWrapper>
                    ) : (
                      photoContent
                    );
                  })}
                </div>
                <div className={`ye2-prop-highlights-col-2 ${col2Styles}`}>
                  {[2, 3].map((placeholder, index) => {
                    let prop = currentSoldListings[index + 2];
                    const photoContent = (
                      <div className="row1-photo-col" key={placeholder}>
                        {isAgentPage && showButton ? (
                          <div>
                            <div className="property-number">{index + 3}</div>
                            {handleSelect && (
                              <button
                                className="property-delete-btn"
                                style={{
                                  position: "absolute",
                                  top: "40px",
                                  left: "5px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  border: "1px solid #dc3545",
                                  borderRadius: "3px",
                                  width: "50px",
                                  height: "18px",
                                  background: "#fff",
                                  color: "#dc3545",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "0",
                                  zIndex: 10001,
                                }}
                                title="Delete Property"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelect(prop, false);
                                }}
                              >
                                Delete
                              </button>
                            )}
                            <div
                              className="property-edit-photo-btn"
                              onClick={() => openEditDialogFn(prop)}
                            >
                              Edit
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        <YETwoHighlightsProp
                          prop={prop}
                          agentData={agentData}
                          currentSoldListings={currentSoldListings}
                          useAlt={useAlt}
                          has3Footers={has3Footers}
                          index={index}
                        />
                      </div>
                    );

                    return isDraggable && SortablePhotoWrapper ? (
                      <SortablePhotoWrapper
                        key={placeholder}
                        prop={prop}
                        activeId={activeId}
                      >
                        {photoContent}
                      </SortablePhotoWrapper>
                    ) : (
                      photoContent
                    );
                  })}
                </div>
              </div>
            </div>
          ) : use6Props ? (
            <div
              className={`ye2-property-highlight-row-1 ${
                extraQuadrantStyles
                  ? extraQuadrantStyles
                  : "quadrant-prop-layout 6-prop-layout"
              }`}
            >
              <div className="ye2-property-highlight-inner-photo-container">
                <div className="ye2-prop-highlights-col-1">
                  {[0, 1].map((placeholder, index) => {
                    let prop = currentSoldListings[index];
                    const photoContent = (
                      <div className="row1-photo-col" key={placeholder}>
                        {isAgentPage && showButton ? (
                          <div>
                            <div className="property-number">{index + 1}</div>
                            {handleSelect && (
                              <button
                                className="property-delete-btn"
                                style={{
                                  position: "absolute",
                                  top: "40px",
                                  left: "5px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  border: "1px solid #dc3545",
                                  borderRadius: "3px",
                                  width: "50px",
                                  height: "18px",
                                  background: "#fff",
                                  color: "#dc3545",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "0",
                                  zIndex: 10001,
                                }}
                                title="Delete Property"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelect(prop, false);
                                }}
                              >
                                Delete
                              </button>
                            )}
                            <div
                              className="property-edit-photo-btn"
                              onClick={() => openEditDialogFn(prop)}
                            >
                              Edit
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        <YETwoHighlightsProp
                          prop={prop}
                          agentData={agentData}
                          currentSoldListings={currentSoldListings}
                          useAlt={useAlt}
                          has3Footers={has3Footers}
                        />
                      </div>
                    );

                    return isDraggable && SortablePhotoWrapper ? (
                      <SortablePhotoWrapper
                        key={placeholder}
                        prop={prop}
                        activeId={activeId}
                      >
                        {photoContent}
                      </SortablePhotoWrapper>
                    ) : (
                      photoContent
                    );
                  })}
                </div>
                <div className={`ye2-prop-highlights-col-2 ${col2Styles}`}>
                  {[2, 3].map((placeholder, index) => {
                    let prop = currentSoldListings[index + 2];
                    const photoContent = (
                      <div className="row1-photo-col" key={placeholder}>
                        {isAgentPage && showButton ? (
                          <div>
                            <div className="property-number">{index + 3}</div>
                            {handleSelect && (
                              <button
                                className="property-delete-btn"
                                style={{
                                  position: "absolute",
                                  top: "40px",
                                  left: "5px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  border: "1px solid #dc3545",
                                  borderRadius: "3px",
                                  width: "50px",
                                  height: "18px",
                                  background: "#fff",
                                  color: "#dc3545",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "0",
                                  zIndex: 10001,
                                }}
                                title="Delete Property"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelect(prop, false);
                                }}
                              >
                                Delete
                              </button>
                            )}
                            <div
                              className="property-edit-photo-btn"
                              onClick={() => openEditDialogFn(prop)}
                            >
                              Edit
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        <YETwoHighlightsProp
                          prop={prop}
                          agentData={agentData}
                          currentSoldListings={currentSoldListings}
                          useAlt={useAlt}
                          has3Footers={has3Footers}
                        />
                      </div>
                    );

                    return isDraggable && SortablePhotoWrapper ? (
                      <SortablePhotoWrapper
                        key={placeholder}
                        prop={prop}
                        activeId={activeId}
                      >
                        {photoContent}
                      </SortablePhotoWrapper>
                    ) : (
                      photoContent
                    );
                  })}
                </div>

                <div className={`ye2-prop-highlights-col-2 ${col2Styles}`}>
                  {[4, 5].map((placeholder, index) => {
                    let prop = currentSoldListings[index + 4];
                    const photoContent = (
                      <div className="row1-photo-col" key={placeholder}>
                        {isAgentPage && showButton ? (
                          <div>
                            <div className="property-number">{index + 5}</div>
                            {handleSelect && (
                              <button
                                className="property-delete-btn"
                                style={{
                                  position: "absolute",
                                  top: "40px",
                                  left: "5px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  border: "1px solid #dc3545",
                                  borderRadius: "3px",
                                  width: "50px",
                                  height: "18px",
                                  background: "#fff",
                                  color: "#dc3545",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "0",
                                  zIndex: 10001,
                                }}
                                title="Delete Property"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelect(prop, false);
                                }}
                              >
                                Delete
                              </button>
                            )}
                            <div
                              className="property-edit-photo-btn"
                              onClick={() => openEditDialogFn(prop)}
                            >
                              Edit
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        <YETwoHighlightsProp
                          prop={prop}
                          agentData={agentData}
                          currentSoldListings={currentSoldListings}
                          useAlt={useAlt}
                          has3Footers={has3Footers}
                        />
                      </div>
                    );

                    return isDraggable && SortablePhotoWrapper ? (
                      <SortablePhotoWrapper
                        key={placeholder}
                        prop={prop}
                        activeId={activeId}
                      >
                        {photoContent}
                      </SortablePhotoWrapper>
                    ) : (
                      photoContent
                    );
                  })}
                </div>
              </div>
            </div>
          ) : use4Props ? (
            <div
              className={`ye2-property-highlight-row-1 prop-3-layout using-4-prop-layout`}
            >
              <div className="ye2-property-highlight-inner-photo-container">
                <div className="ye2-prop-highlights-col-1">
                  {[0].map((placeholder, index) => {
                    let prop = currentSoldListings[index];
                    const photoContent = (
                      <div className="row1-photo-col" key={placeholder}>
                        {isAgentPage && showButton ? (
                          <div>
                            <div className="property-number">{index + 1}</div>
                            {handleSelect && (
                              <button
                                className="property-delete-btn"
                                style={{
                                  position: "absolute",
                                  top: "40px",
                                  left: "5px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  border: "1px solid #dc3545",
                                  borderRadius: "3px",
                                  width: "50px",
                                  height: "18px",
                                  background: "#fff",
                                  color: "#dc3545",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "0",
                                  zIndex: 10001,
                                }}
                                title="Delete Property"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelect(prop, false);
                                }}
                              >
                                Delete
                              </button>
                            )}
                            <div
                              className="property-edit-photo-btn"
                              onClick={() => openEditDialogFn(prop)}
                            >
                              Edit
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        <YETwoHighlightsProp
                          prop={prop}
                          agentData={agentData}
                          currentSoldListings={currentSoldListings}
                          useAlt={useAlt}
                          use1Prop3Photos={use1Prop3Photos}
                          has3Footers={has3Footers}
                          index={index}
                        />
                      </div>
                    );

                    return isDraggable && SortablePhotoWrapper ? (
                      <SortablePhotoWrapper
                        key={placeholder}
                        prop={prop}
                        activeId={activeId}
                      >
                        {photoContent}
                      </SortablePhotoWrapper>
                    ) : (
                      photoContent
                    );
                  })}
                </div>
                <div className="ye2-prop-highlights-col-2">
                  {[1, 2, 3].map((placeholder, index) => {
                    let prop = currentSoldListings[index + 1];
                    const photoContent = (
                      <div className="row1-photo-col" key={placeholder}>
                        {isAgentPage && showButton ? (
                          <div>
                            <div className="property-number">{index + 2}</div>
                            {handleSelect && (
                              <button
                                className="property-delete-btn"
                                style={{
                                  position: "absolute",
                                  top: "40px",
                                  left: "5px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  border: "1px solid #dc3545",
                                  borderRadius: "3px",
                                  width: "50px",
                                  height: "18px",
                                  background: "#fff",
                                  color: "#dc3545",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "0",
                                  zIndex: 10001,
                                }}
                                title="Delete Property"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelect(prop, false);
                                }}
                              >
                                Delete
                              </button>
                            )}
                            <div
                              className="property-edit-photo-btn"
                              onClick={() => openEditDialogFn(prop)}
                            >
                              Edit
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        <YETwoHighlightsProp
                          prop={prop}
                          agentData={agentData}
                          currentSoldListings={currentSoldListings}
                          useAlt={useAlt}
                          has3Footers={has3Footers}
                        />
                      </div>
                    );

                    return isDraggable && SortablePhotoWrapper ? (
                      <SortablePhotoWrapper
                        key={placeholder}
                        prop={prop}
                        activeId={activeId}
                      >
                        {photoContent}
                      </SortablePhotoWrapper>
                    ) : (
                      photoContent
                    );
                  })}
                </div>
              </div>
            </div>
          ) : use1Prop3Photos ? (
            <div
              className={`ye2-property-highlight-row-1 ${
                use3Props && "prop-3-layout"
              }`}
            >
              <div className="ye2-property-highlight-inner-photo-container">
                <div className="ye2-prop-highlights-col-1">
                  {[0].map((placeholder, index) => {
                    let prop = currentSoldListings[index];
                    const photoContent = (
                      <div className="row1-photo-col" key={placeholder}>
                        {isAgentPage && showButton ? (
                          <div>
                            <div className="property-number">{index + 1}</div>
                            {handleSelect && (
                              <button
                                className="property-delete-btn"
                                style={{
                                  position: "absolute",
                                  top: "40px",
                                  left: "5px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  border: "1px solid #dc3545",
                                  borderRadius: "3px",
                                  width: "50px",
                                  height: "18px",
                                  background: "#fff",
                                  color: "#dc3545",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "0",
                                  zIndex: 10001,
                                }}
                                title="Delete Property"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelect(prop, false);
                                }}
                              >
                                Delete
                              </button>
                            )}
                            <div
                              className="property-edit-photo-btn"
                              onClick={() => openEditDialogFn(prop)}
                            >
                              Edit
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        <YETwoHighlightsProp
                          prop={prop}
                          agentData={agentData}
                          currentSoldListings={currentSoldListings}
                          useAlt={useAlt}
                          use1Prop3Photos={use1Prop3Photos}
                          has3Footers={has3Footers}
                        />
                      </div>
                    );

                    return isDraggable && SortablePhotoWrapper ? (
                      <SortablePhotoWrapper
                        key={placeholder}
                        prop={prop}
                        activeId={activeId}
                      >
                        {photoContent}
                      </SortablePhotoWrapper>
                    ) : (
                      photoContent
                    );
                  })}
                </div>
                <div className="ye2-prop-highlights-col-2">
                  {[1, 2].map((placeholder, index) => {
                    let prop = currentSoldListings[index + 1];
                    let firstProp = currentSoldListings[0];
                    const photoContent = (
                      <div className="row1-photo-col" key={placeholder}>
                        {isAgentPage && showButton ? (
                          <div>
                            <div className="property-number">{index + 2}</div>
                            {handleSelect && (
                              <button
                                className="property-delete-btn"
                                style={{
                                  position: "absolute",
                                  top: "40px",
                                  left: "5px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  border: "1px solid #dc3545",
                                  borderRadius: "3px",
                                  width: "50px",
                                  height: "18px",
                                  background: "#fff",
                                  color: "#dc3545",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "0",
                                  zIndex: 10001,
                                }}
                                title="Delete Property"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelect(prop, false);
                                }}
                              >
                                Delete
                              </button>
                            )}
                            <div
                              className="property-edit-photo-btn"
                              onClick={() => openEditDialogFn(prop)}
                            >
                              Edit
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        <YETwoHighlightsProp
                          prop={prop}
                          firstProp={firstProp}
                          agentData={agentData}
                          currentSoldListings={currentSoldListings}
                          useAlt={useAlt}
                          use1Prop3Photos={use1Prop3Photos}
                          altBanner={true}
                          showBanner={index === 0 ? false : true}
                          has3Footers={has3Footers}
                        />
                      </div>
                    );

                    return isDraggable && SortablePhotoWrapper ? (
                      <SortablePhotoWrapper
                        key={placeholder}
                        prop={prop}
                        activeId={activeId}
                      >
                        {photoContent}
                      </SortablePhotoWrapper>
                    ) : (
                      photoContent
                    );
                  })}
                </div>
              </div>
            </div>
          ) : use1Prop ? (
            <div className={`ye2-property-highlight-row-1 prop-1-layout`}>
              <div className="ye2-property-highlight-inner-photo-container">
                <div className="ye2-prop-highlights-col-1">
                  {[0].map((placeholder, index) => {
                    let prop = currentSoldListings[index];
                    const photoContent = (
                      <div className="row1-photo-col" key={placeholder}>
                        {isAgentPage && showButton ? (
                          <div>
                            <div className="property-number">{index + 1}</div>
                            {handleSelect && (
                              <button
                                className="property-delete-btn"
                                style={{
                                  position: "absolute",
                                  top: "40px",
                                  left: "5px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  border: "1px solid #dc3545",
                                  borderRadius: "3px",
                                  width: "50px",
                                  height: "18px",
                                  background: "#fff",
                                  color: "#dc3545",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "0",
                                  zIndex: 10001,
                                }}
                                title="Delete Property"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelect(prop, false);
                                }}
                              >
                                Delete
                              </button>
                            )}
                            <div
                              className="property-edit-photo-btn"
                              onClick={() => openEditDialogFn(prop)}
                            >
                              Edit
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        <YETwoHighlightsProp
                          prop={prop}
                          agentData={agentData}
                          currentSoldListings={currentSoldListings}
                          useAlt={useAlt}
                          use1Prop={use1Prop}
                          mlsAreaID={mlsAreaID}
                          has3Footers={has3Footers}
                        />
                      </div>
                    );

                    return isDraggable && SortablePhotoWrapper ? (
                      <SortablePhotoWrapper
                        key={placeholder}
                        prop={prop}
                        activeId={activeId}
                      >
                        {photoContent}
                      </SortablePhotoWrapper>
                    ) : (
                      photoContent
                    );
                  })}
                </div>
              </div>
              {/*{" "}
              {!isAgentPage && (
                <QVFourTestimonial
                  testimonials={testimonials}
                  agentData={agentData}
                  printVersion={printVersion}
                  fromEditor={fromEditor}
                  currentArea={currentArea}
                  tallerStyles={true}
                />
              )}{" "}
              */}
            </div>
          ) : use3Props ? (
            <div
              className={`ye2-property-highlight-row-1 ${
                use3Props && "prop-3-layout"
              }`}
            >
              <div className="ye2-property-highlight-inner-photo-container">
                <div className="ye2-prop-highlights-col-1">
                  {[0].map((placeholder, index) => {
                    let prop = currentSoldListings[index];
                    const photoContent = (
                      <div className="row1-photo-col" key={placeholder}>
                        {isAgentPage && showButton ? (
                          <div>
                            <div className="property-number">{index + 1}</div>
                            {handleSelect && (
                              <button
                                className="property-delete-btn"
                                style={{
                                  position: "absolute",
                                  top: "40px",
                                  left: "5px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  border: "1px solid #dc3545",
                                  borderRadius: "3px",
                                  width: "50px",
                                  height: "18px",
                                  background: "#fff",
                                  color: "#dc3545",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "0",
                                  zIndex: 10001,
                                }}
                                title="Delete Property"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelect(prop, false);
                                }}
                              >
                                Delete
                              </button>
                            )}
                            <div
                              className="property-edit-photo-btn"
                              onClick={() => openEditDialogFn(prop)}
                            >
                              Edit
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        <YETwoHighlightsProp
                          prop={prop}
                          agentData={agentData}
                          currentSoldListings={currentSoldListings}
                          useAlt={useAlt}
                          use1Prop3Photos={use1Prop3Photos}
                          has3Footers={has3Footers}
                        />
                      </div>
                    );

                    return isDraggable && SortablePhotoWrapper ? (
                      <SortablePhotoWrapper
                        key={placeholder}
                        prop={prop}
                        activeId={activeId}
                      >
                        {photoContent}
                      </SortablePhotoWrapper>
                    ) : (
                      photoContent
                    );
                  })}
                </div>
                <div className="ye2-prop-highlights-col-2">
                  {[1, 2].map((placeholder, index) => {
                    let prop = currentSoldListings[index + 1];
                    const photoContent = (
                      <div className="row1-photo-col" key={placeholder}>
                        {isAgentPage && showButton ? (
                          <div>
                            <div className="property-number">{index + 2}</div>
                            {handleSelect && (
                              <button
                                className="property-delete-btn"
                                style={{
                                  position: "absolute",
                                  top: "40px",
                                  left: "5px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  border: "1px solid #dc3545",
                                  borderRadius: "3px",
                                  width: "50px",
                                  height: "18px",
                                  background: "#fff",
                                  color: "#dc3545",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "0",
                                  zIndex: 10001,
                                }}
                                title="Delete Property"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelect(prop, false);
                                }}
                              >
                                Delete
                              </button>
                            )}
                            <div
                              className="property-edit-photo-btn"
                              onClick={() => openEditDialogFn(prop)}
                            >
                              Edit
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        <YETwoHighlightsProp
                          prop={prop}
                          agentData={agentData}
                          currentSoldListings={currentSoldListings}
                          useAlt={useAlt}
                          has3Footers={has3Footers}
                        />
                      </div>
                    );

                    return isDraggable && SortablePhotoWrapper ? (
                      <SortablePhotoWrapper
                        key={placeholder}
                        prop={prop}
                        activeId={activeId}
                      >
                        {photoContent}
                      </SortablePhotoWrapper>
                    ) : (
                      photoContent
                    );
                  })}
                </div>
              </div>
            </div>
          ) : use2Props ? (
            <div
              className={`ye2-property-highlight-row-1 ${
                use2Props && "prop-2-layout"
              }`}
            >
              <div className="ye2-property-highlight-inner-photo-container">
                <div className="ye2-prop-highlights-col-1">
                  {[0].map((placeholder, index) => {
                    let prop = currentSoldListings[index];
                    const photoContent = (
                      <div className="row1-photo-col" key={placeholder}>
                        {isAgentPage && showButton ? (
                          <div>
                            <div className="property-number">{index + 1}</div>
                            {handleSelect && (
                              <button
                                className="property-delete-btn"
                                style={{
                                  position: "absolute",
                                  top: "40px",
                                  left: "5px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  border: "1px solid #dc3545",
                                  borderRadius: "3px",
                                  width: "50px",
                                  height: "18px",
                                  background: "#fff",
                                  color: "#dc3545",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "0",
                                  zIndex: 10001,
                                }}
                                title="Delete Property"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelect(prop, false);
                                }}
                              >
                                Delete
                              </button>
                            )}
                            <div
                              className="property-edit-photo-btn"
                              onClick={() => openEditDialogFn(prop)}
                            >
                              Edit
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        <YETwoHighlightsProp
                          prop={prop}
                          agentData={agentData}
                          currentSoldListings={currentSoldListings}
                          use2Props={use2Props}
                          useAlt={useAlt}
                          has3Footers={has3Footers}
                          // use1Prop3Photos={use1Prop3Photos}
                        />
                      </div>
                    );

                    return isDraggable && SortablePhotoWrapper ? (
                      <SortablePhotoWrapper
                        key={placeholder}
                        prop={prop}
                        activeId={activeId}
                      >
                        {photoContent}
                      </SortablePhotoWrapper>
                    ) : (
                      photoContent
                    );
                  })}
                </div>
                <div className="ye2-prop-highlights-col-2">
                  {[1].map((placeholder, index) => {
                    let prop = currentSoldListings[index + 1];
                    const photoContent = (
                      <div className="row1-photo-col" key={placeholder}>
                        {isAgentPage && showButton ? (
                          <div>
                            <div className="property-number">{index + 2}</div>
                            {handleSelect && (
                              <button
                                className="property-delete-btn"
                                style={{
                                  position: "absolute",
                                  top: "40px",
                                  left: "5px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  border: "1px solid #dc3545",
                                  borderRadius: "3px",
                                  width: "50px",
                                  height: "18px",
                                  background: "#fff",
                                  color: "#dc3545",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "0",
                                  zIndex: 10001,
                                }}
                                title="Delete Property"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelect(prop, false);
                                }}
                              >
                                Delete
                              </button>
                            )}
                            <div
                              className="property-edit-photo-btn"
                              onClick={() => openEditDialogFn(prop)}
                            >
                              Edit
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        <YETwoHighlightsProp
                          prop={prop}
                          agentData={agentData}
                          currentSoldListings={currentSoldListings}
                          useAlt={useAlt}
                          use2Props={use2Props}
                          has3Footers={has3Footers}
                        />
                      </div>
                    );

                    return isDraggable && SortablePhotoWrapper ? (
                      <SortablePhotoWrapper
                        key={placeholder}
                        prop={prop}
                        activeId={activeId}
                      >
                        {photoContent}
                      </SortablePhotoWrapper>
                    ) : (
                      photoContent
                    );
                  })}
                </div>
                {listgenUserID === "x101001" && (
                  <div className="centered-representation-text-under-2-props">
                    <p>I Am Representing the Sellers</p>
                  </div>
                )}
              </div>
              {!isAgentPage && (
                <QVFourTestimonial
                  testimonials={testimonials}
                  agentData={agentData}
                  printVersion={printVersion}
                  currentArea={currentArea}
                  tallerStyles={true}
                  fromEditor={fromEditor}
                />
              )}
            </div>
          ) : switchedProperties ? (
            <>
              {row2}
              {row1}
            </>
          ) : (
            <>
              {row1}
              {row2}
            </>
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    currentArea: state.pma.currentArea,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    switchPropertyHighlightsPage: (listgenUserID, mlsAreaID, isBackPage) => {
      dispatch(
        pmaActions.switchPropertyHighlightsPage(
          listgenUserID,
          mlsAreaID,
          isBackPage,
        ),
      );
    },
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(YETwoPropertyHighlight);
